import ClipboardJS from 'clipboard'

window.addEventListener('DOMContentLoaded', () => {
  const clipboard = new ClipboardJS('.c-btn--clipboard');

  clipboard.on('success', e => {
    const btn = e.trigger;
    btn.classList.add('is-copied');

    setTimeout(() => {
      btn.classList.remove('is-copied');
      e.clearSelection();
    }, 900);
  });
});
